import React, { useState } from 'react';
import { useIsEnabled, useAsyncEffect, useJanitor } from '../../../../hooks';
import analytics from '../../../../modules/analytics';
import stateManager from '../../../../modules/user/stateManager';
import withStore from '../../../withStore';

import { NCD_CANCELLATION_RESTRICTION } from '../../appointment/ApptCancelModal/ApptCancelModalContainer';
import { NCD_POLICY_NOTIFICATION_ACTION, TRACKING_PREFIX } from './constants';

import NcdCancellationPolicyNotification, { NotificationProps } from './NcdCancellationPolicyNotification';

type NcdCancellationPolicyNotificationProps = {
  providerId: number;
  notification: NotificationProps;
};

const NcdCancellationPolicyNotificationContainer:
React.FC<NcdCancellationPolicyNotificationProps> = ({
  providerId,
  notification,
}) => {
  const switchEnabled = useIsEnabled(NCD_CANCELLATION_RESTRICTION);
  const [showNotification, setShowNotification] = useState(false);
  const janitor = useJanitor();

  const onCTAClick = () => {
    analytics.track(`${TRACKING_PREFIX}Clicked`, {
      provider_id: providerId,
    });
  };

  const onAccept = () => {
    stateManager.addAction(NCD_POLICY_NOTIFICATION_ACTION, true);
    setShowNotification(false);
  };

  useAsyncEffect(async () => {
    const hasAcceptedNcdPolicy = await janitor.addPromise(
      stateManager.getActionValue(NCD_POLICY_NOTIFICATION_ACTION),
    );
    if (switchEnabled && !hasAcceptedNcdPolicy) {
      analytics.track(`${TRACKING_PREFIX}Viewed`, {
        provider_id: providerId,
      });
      setShowNotification(true);
    }
  }, [switchEnabled]);

  return showNotification && (
    <NcdCancellationPolicyNotification
      notification={notification}
      providerId={providerId}
      onCTAClick={onCTAClick}
      onAccept={onAccept}
    />
  );
};

export default withStore(NcdCancellationPolicyNotificationContainer);
